import { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import SubmitButton from "../../components/controls/SubmitButton/SubmitButton";
import Loading from "../../components/Loading/Loading";

import nexiLogo from "../.././assets/logo-nexi-group.png";
import styles from './SubsidiaryManagement.module.css';
import { useHistory } from "react-router-dom";
import GenericModal from "../../UI/GenericModal";
import { LegalEntitySubsidiaryServicesApi } from "../../service";
import { isSuperuserValue } from "../../access/access";

const SubsidiaryManagement = () => {
  const [subsidiariesList, setSubsidiariesList] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState();

  const history = useHistory();

  const [modalShow, setModalShow] = useState(false);
  const [modalAction, setModalAction] = useState();
  const [modalTitle, setModalTitle] = useState();
  const [modalMessage, setModalMessage] = useState();
  const [modalType, setModalType] = useState();

  useEffect(() => {
    if (!isSuperuserValue()) {
      history.push("/home");
    }
    setIsLoading(true);
    let mounted = true;

    const subsidiaryServicesApi = new LegalEntitySubsidiaryServicesApi();
    subsidiaryServicesApi.getLegalEntitySubsidiaryMonitor( (error, data) => {
      if (mounted) {
        if (!error) {
          console.log("Api Subsidiaries list: ", data);
          setSubsidiariesList(data);
        } else {
          setError(() => {
            throw new Error ("");
            // throw new Error ("Error " + (error.response ? error.response.statusCode : "") + " " + error.message);
          })
        }
      }

      setIsLoading(false);
    });

    return () => {
      mounted = false;
    }
  }, []);

  const editSubsidiaryHandler = (subsidiaryId) => {
    setIsLoading(true);
      history.push('/edit-subsidiary?subsidiaryId='+subsidiaryId);
  }

  const deleteSubsidiaryHandler = (subsidiary) => {
    setIsLoading(true);
    const subsidiaryServicesApi = new LegalEntitySubsidiaryServicesApi();
    subsidiaryServicesApi.deleteLegalEntitySubsidiaryById(subsidiary.id, (error, data) => {
      if (!error) {
        modalDataHandler("", `The subsidiary "${subsidiary.name}" was deleted`, 'notification', () => window.location.reload())  
      } else {
        modalDataHandler(`Error ${(error.response ? error.response.statusCode : "")}`, "The subsidiary was not deleted!", 'error', () => setModalShow(false));
      }
    })
  }

  const modalDataHandler = (title, message, modType, action) => {
    setModalAction(() => action );
    setModalTitle(title);
    setModalMessage(message);
    setModalShow(true);
    setModalType(modType);
  }

  const modalCloseHandler = () => {
    setModalShow(false)
  }

  return <div className="pt-5 pb-2 d-flex justify-content-center align-items-center position-relative">
    <img
      src={nexiLogo}
      className={`${styles.logo}`}
      alt="nexi-group"
    />
    <GenericModal
        show={modalShow}
        handleClose={modalCloseHandler}
        action={modalAction}
        title={modalTitle}
        message={modalMessage}
        modalType={modalType}
      />
    {!isLoading && <table className={`${styles.tableStyle}`}>
      <thead>
        <tr>
          <th className="px-2">Parent Company</th>
          <th className="px-2">Subsidiary</th>
          <th className={`${styles.buttonsCol} px-1`}>
            <SubmitButton class={styles.newElementButton} click={() => history.push('/new-subsidiary')} align="center">New</SubmitButton>
          </th>
        </tr>
      </thead>
      <tbody>
        {subsidiariesList.map( (el, index) => {
          const subsidiary = el.legalEntitySubsidiaries[0];
          return (
            <tr key={index}>
              <td className="p-3">{el.name}</td>
              <td className="p-3">{subsidiary.name}</td>
              <td>
                <div className="d-flex">
                  <SubmitButton click={() => editSubsidiaryHandler(subsidiary.id)}>Edit</SubmitButton>
                    <SubmitButton click={() => modalDataHandler(
                      "Delete Subsidiary",
                      `Delete Subsidiary "${subsidiary.name}"?`,
                      'confirmation',
                      () => deleteSubsidiaryHandler(subsidiary) 
                    )}
                    disabled={!subsidiary.deletable}>Delete</SubmitButton>
                </div>
              </td>
            </tr>
          )
        })}
      </tbody>
    </table>}
    {isLoading && <Loading />}
  </div>;
};

export default SubsidiaryManagement;
